import UiAction from "./index";
import HasInfoPostsOrUiAction from "./has-info-posts-or-ui-action";

// if this is for feautre post ui form
$(() => {
  if ($("#feature_post_ui_form").length > 0) {
    const featurePostUiAction = new UiAction(
      ".main_ui_actions",
      ".main_ui_action_radio_buttons",
      ".main_ui_action_items",
      {
        isSubPageRequired: true,
        isSubPage: false,
      },
      {
        hasSubPage: true,
        hasCallToAction: false,
      }
    );

    const subPageUiAction = new UiAction(
      "#sub_page_ui_actions",
      "#sub_page_ui_action_radio_buttons",
      "#sub_page_ui_action_items",
      {
        isSubPageRequired: false,
        isSubPage: true,
      },
      {
        hasSubPage: true,
        hasCallToAction: true,
      }
    );

    const hasInfoPostsOrUiAction = new HasInfoPostsOrUiAction(
      "#sub_page_contents #has_info_posts_or_ui_action",
      () => {
        subPageUiAction.controls.hide();
        subPageUiAction.controls.setDestroyFlag(true);
        subPageUiAction.controls.setDestroyInfoPostFlag(false);
      },
      () => {
        subPageUiAction.controls.show();
        subPageUiAction.controls.setDestroyFlag(false);
        subPageUiAction.controls.setDestroyInfoPostFlag(true);
      }
    );

    featurePostUiAction.attach();
    subPageUiAction.attach();
    hasInfoPostsOrUiAction.attach();
  }
});
